<rt-dialog-header [heading]="title" [hasBlueBg]="true" [hasDivider]="false"></rt-dialog-header>

<div class="confirm-body" space>
  @if (message) {
    <p [innerHTML]="message"></p>
  }

  @if (list.length) {
    <ul class="list">
      @for (item of list; track trackByValue($index, item)) {
        <li [innerHTML]="item" class="list__item"></li>
      }
    </ul>
  }

  @if (visibleTags.length) {
    <rt-group margin-tb-small class="tags">
      @for (tag of visibleTags; track trackByValue($index, tag)) {
        <rt-tag [name]="tag" [isClickable]="false" [isHoverable]="false"> </rt-tag>
      }
    </rt-group>
    @if (tagsCollapseActive) {
      <div layout>
        <rt-button size="small" (click)="toggleTagsCollapse()" variant="plain">
          @if (tagsCollapsed) {
            <span>{{ showMoreLabel }} ({{ tags.length - visibleTags.length }})</span>
          }
          @if (!tagsCollapsed) {
            <span>{{ showLessLabel }}</span>
          }
          <rt-icon size="small" [name]="tagsCollapsed ? 'expand-more' : 'expand-less'"></rt-icon>
        </rt-button>
      </div>
    }
  }

  <ng-content></ng-content>
  @if (tmpCheckboxes.length > 0) {
    <div
      class="form"
      [class.with-top-border]="message"
      [attr.padding-top-medium]="!!message ? '' : null"
    >
      <div>
        @for (option of tmpCheckboxes; track trackByCheckbox(i); let i = $index; let last = $last) {
          <div class="choice-item">
            <rt-group>
              <div class="option-container">
                <rt-checkbox
                  [checked]="option.value"
                  (valueChange)="handleCheckboxValueChange(i, $any($event))"
                >
                  <span
                    class="label"
                    [innerHTML]="option.label"
                    [class.marked]="last && emphasizeLastCheckbox"
                  ></span>
                </rt-checkbox>
              </div>
            </rt-group>
          </div>
        }
      </div>
    </div>
  }
  @if (footerMessage) {
    <rt-divider margin-bottom-small></rt-divider>
    <p [innerHTML]="footerMessage"></p>
  }
</div>

<rt-divider></rt-divider>

<div class="confirm-actions" [class.safe-footer]="safeFooter" padding-lr-medium padding-tb-small>
  <rt-group
    variant="horizontal"
    [attr.layout-justify-flex-end]="confirmActionsLayout === 'end' || null"
    [attr.layout-space-between]="confirmActionsLayout === 'space-between' || null"
  >
    @if (isCancelable) {
      <rt-button (click)="cancel()" variant="plain">
        {{ cancelLabel }}
      </rt-button>
    }
    <rt-button [variant]="buttonVariantMap[variant]" [disabled]="!isFormValid" (click)="confirm()">
      {{ agreeLabel }}
    </rt-button>
  </rt-group>
</div>
